export const minestoneProjects = [
  {
    name: "React Router page ",
    description:
      "A page to demostrate React Routing and API calls to json placeholder",
    img: "https://i.postimg.cc/Mp8przNb/Screenshot-84.png",
    skills: ["HTML", "CSS", "Javascript", "React"],
    link_github: "https://github.com/KINGSLEYEHAPA/React-Router-Assignment",
    link_deployment: " https://react-router-assignment-kappa.vercel.app/",
  },
  {
    name: "Kay-Foods",
    description:
      "A food ordering app.The application make calls to a food API and return hundreds of food product for the customer to buy. ",
    img: "https://i.postimg.cc/0QLzkDWh/food.png",
    skills: ["HTML", "CSS", "Javascript", "React", "React-Redux"],
    link_github: "https://github.com/KINGSLEYEHAPA/Food-Ordering-Application",
    link_deployment: " https://food-ordering-orpin.vercel.app/",
  },
  {
    name: "Edvora",
    description:
      "The application takes a user station code and display rides closest to his station,past and upcoming rides.",
    img: "https://i.postimg.cc/rFGDTdSY/edvora.png",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "React",

      "React-Redux",
      "TailWindCSS",
    ],
    link_github: "https://github.com/KINGSLEYEHAPA/edvora-ride-hailing-app",
    link_deployment: " https://edvora-1.vercel.app/",
  },
  {
    name: "Traveler",
    description:
      "A travel App. User can type in location and get weather report,news and attractions in the location.",
    img: "https://i.postimg.cc/YCbj4JD6/traveler.png",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "React",
      "React-Redux",
      "TailWindCSS",
    ],
    link_github: "https://github.com/KINGSLEYEHAPA/stutern-traveler-app",
    link_deployment: "https://stutern-traveler-app-project.vercel.app/",
  },
  {
    name: "Stutern Website Landing page",
    description: "A static page of Stutern, my coding school.",
    img: "https://i.postimg.cc/nzQLPMF2/stutern.png",
    skills: ["HTML", "CSS", "Javascript"],
    link_github:
      "https://github.com/KINGSLEYEHAPA/Stutern-Website-Landing-Page-Assignment",
    link_deployment:
      "https://kingsleyehapa.github.io/Stutern-Website-Landing-Page-Assignment/",
  },
  {
    name: "EL Cinemas",
    description: "A static email template",
    img: "https://i.postimg.cc/jdTjMsG6/email-template.png",
    skills: ["HTML", "CSS"],
    link_github: "https://github.com/KINGSLEYEHAPA/Email-Template",
    link_deployment: "https://codepen.io/kingsleyehapa/full/MWvYgmb",
  },
  {
    name: "Arsenal Fans Club Naija",
    description:
      "Arsenal fans club naija is a blog written to dynamically create navigation elements to hold navigation links to the page.Written with Javascript to scroll to each section of the page",
    img: "https://i.postimg.cc/fWcztGJV/arsenal-blog.png",
    skills: ["HTML", "CSS", "Javascript"],
    link_github:
      "https://github.com/KINGSLEYEHAPA/Multisection-Landing-Page-Project",
    link_deployment:
      " https://kingsleyehapa.github.io/Multisection-Landing-Page-Project/",
  },
  {
    name: "Kay-Dad Wears",
    description: "A Fashion store ",
    img: "https://i.postimg.cc/bwJp5dLn/kay-dad.png",
    skills: ["HTML", "CSS", "Javascript"],
    link_github: "https://github.com/KINGSLEYEHAPA/Bi-weekly-Challenge-3",
    link_deployment:
      " https://kingsleyehapa.github.io/Bi-weekly-Challenge-3/src/",
  },

  {
    name: "Coder-Kingsley Omozogie Ehapa",
    description: "My Portfolio Version 1, 2022",
    img: "https://i.postimg.cc/MZPc76RR/personal.png",
    skills: ["HTML", "CSS", "Javascript", "React", "TailWindCSS"],
    link_github: "https://github.com/KINGSLEYEHAPA/Kingsley-Ehapa-Portfolio",
    link_deployment: "https://sharp-fermat-7b6e4e.netlify.app/",
  },
];

export const capstoneProjects = [
  {
    name: "PassEasy",
    description:
      "Pass Easy.The sure platform to prepare for exams in Wassce,Utme and Postume. This online educational platform is a Nigerian student companion.I built this application with React, Redux and TailwindCss",
    img: "https://i.postimg.cc/QCVr2K2s/PassEasy.png",
    skills: ["Javascript", "React", "TailWindCSS", "Redux", "Redux-Persist"],
    link_github:
      "https://github.com/KINGSLEYEHAPA/pass-easy-stutern-personal-project",
    link_deployment: "https://sprightly-gaufre-8a6587.netlify.app/",
  },
];

export const myRecentProjects = [
  {
    name: "Huluv7",
    description:
      "Huluv7-a hulu movie app clone. This application give the users access to information about trending movies. Users can look up different genres of movies.",
    img: "https://i.postimg.cc/MHB7B1Tm/Screenshot-121.png",
    skills: ["Javascript", "TailWindCSS", "NextJs", "AJAX"],
    link_github: "https://github.com/KINGSLEYEHAPA/Hulu-v7",
    link_deployment: "https://hulu-v7.vercel.app/",
  },
];

export const interTrackProjects = [
  {
    name: "Afrive Bookstore",
    description:
      "This is a platform that display and sell books by African Authors,I built the frontend,worked with a Backend Engineer and a UI/UX designer",
    img: "https://i.postimg.cc/fR1HdjVH/Screenshot-172.png",
    skills: [
      "Javascript",
      "React",
      "TailWindCSS",
      "Redux-Toolkit",
      "Redux-Persist",
    ],
    link_github: "https://github.com/KINGSLEYEHAPA/Afrive-Project",
    link_deployment: "https://afrive-books.vercel.app/",
  },
];

export const allProjects = [
  {
    name: "Afrive Bookstore",
    description:
      "This is a platform that display and sell books by African Authors,I built the frontend,worked with a Backend Engineer and a UI/UX designer",
    img: "https://i.postimg.cc/fR1HdjVH/Screenshot-172.png",
    skills: [
      "Javascript",
      "React",
      "TailWindCSS",
      "Redux-Toolkit",
      "Redux-Persist",
    ],
    link_github: "https://github.com/KINGSLEYEHAPA/Afrive-Project",
    link_deployment: "https://afrive-books.vercel.app/",
    projectType: "Inter-track Project",
  },
  {
    name: "PassEasy",
    description:
      "Pass Easy.The sure platform to prepare for exams in Wassce,Utme and Postume. This online educational platform is a Nigerian student companion.I built this application with React, Redux and TailwindCss",
    img: "https://i.postimg.cc/QCVr2K2s/PassEasy.png",
    skills: ["Javascript", "React", "TailWindCSS", "Redux", "Redux-Persist"],
    link_github:
      "https://github.com/KINGSLEYEHAPA/pass-easy-stutern-personal-project",
    link_deployment: "https://sprightly-gaufre-8a6587.netlify.app/",
    projectType: "Capstone Project",
  },
  {
    name: "Huluv7",
    description:
      "Huluv7-a hulu movie app clone. This application give the users access to information about trending movies. Users can look up different genres of movies.",
    img: "https://i.postimg.cc/MHB7B1Tm/Screenshot-121.png",
    skills: ["Javascript", "TailWindCSS", "NextJs", "AJAX"],
    link_github: "https://github.com/KINGSLEYEHAPA/Hulu-v7",
    link_deployment: "https://hulu-v7.vercel.app/",
    projectType: "Recent Project",
  },
  {
    name: "React Router page ",
    description:
      "A page to demostrate React Routing and API calls to json placeholder",
    img: "https://i.postimg.cc/Mp8przNb/Screenshot-84.png",
    skills: ["HTML", "CSS", "Javascript", "React"],
    link_github: "https://github.com/KINGSLEYEHAPA/React-Router-Assignment",
    link_deployment: " https://react-router-assignment-kappa.vercel.app/",
    projectType: "Milestone Project",
  },
  {
    name: "Kay-Foods",
    description:
      "A food ordering app.The application make calls to a food API and return hundreds of food product for the customer to buy. ",
    img: "https://i.postimg.cc/0QLzkDWh/food.png",
    skills: ["HTML", "CSS", "Javascript", "React", "React-Redux"],
    link_github: "https://github.com/KINGSLEYEHAPA/Food-Ordering-Application",
    link_deployment: " https://food-ordering-orpin.vercel.app/",
    projectType: "Milestone Project",
  },
  {
    name: "Edvora",
    description:
      "The application takes a user station code and display rides closest to his station,past and upcoming rides.",
    img: "https://i.postimg.cc/rFGDTdSY/edvora.png",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "React",

      "React-Redux",
      "TailWindCSS",
    ],
    link_github: "https://github.com/KINGSLEYEHAPA/edvora-ride-hailing-app",
    link_deployment: " https://edvora-1.vercel.app/",
    projectType: "Milestone Project",
  },
  {
    name: "Traveler",
    description:
      "A travel App. User can type in location and get weather report,news and attractions in the location.",
    img: "https://i.postimg.cc/YCbj4JD6/traveler.png",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "React",
      "React-Redux",
      "TailWindCSS",
    ],
    link_github: "https://github.com/KINGSLEYEHAPA/stutern-traveler-app",
    link_deployment: "https://stutern-traveler-app-project.vercel.app/",
    projectType: "Milestone Project",
  },
  {
    name: "Stutern Website Landing page",
    description: "A static page of Stutern, my coding school.",
    img: "https://i.postimg.cc/nzQLPMF2/stutern.png",
    skills: ["HTML", "CSS", "Javascript"],
    link_github:
      "https://github.com/KINGSLEYEHAPA/Stutern-Website-Landing-Page-Assignment",
    link_deployment:
      "https://kingsleyehapa.github.io/Stutern-Website-Landing-Page-Assignment/",
    projectType: "Milestone Project",
  },
  {
    name: "EL Cinemas",
    description: "A static email template",
    img: "https://i.postimg.cc/jdTjMsG6/email-template.png",
    skills: ["HTML", "CSS"],
    link_github: "https://github.com/KINGSLEYEHAPA/Email-Template",
    link_deployment: "https://codepen.io/kingsleyehapa/full/MWvYgmb",
    projectType: "Milestone Project",
  },
  {
    name: "Arsenal Fans Club Naija",
    description:
      "Arsenal fans club naija is a blog written to dynamically create navigation elements to hold navigation links to the page.Written with Javascript to scroll to each section of the page",
    img: "https://i.postimg.cc/fWcztGJV/arsenal-blog.png",
    skills: ["HTML", "CSS", "Javascript"],
    link_github:
      "https://github.com/KINGSLEYEHAPA/Multisection-Landing-Page-Project",
    link_deployment:
      " https://kingsleyehapa.github.io/Multisection-Landing-Page-Project/",
    projectType: "Milestone Project",
  },
  {
    name: "Kay-Dad Wears",
    description: "A Fashion store ",
    img: "https://i.postimg.cc/bwJp5dLn/kay-dad.png",
    skills: ["HTML", "CSS", "Javascript"],
    link_github: "https://github.com/KINGSLEYEHAPA/Bi-weekly-Challenge-3",
    link_deployment:
      " https://kingsleyehapa.github.io/Bi-weekly-Challenge-3/src/",
    projectType: "Milestone Project",
  },

  {
    name: "Coder-Kingsley Omozogie Ehapa",
    description: "My Portfolio Version 1, 2022",
    img: "https://i.postimg.cc/MZPc76RR/personal.png",
    skills: ["HTML", "CSS", "Javascript", "React", "TailWindCSS"],
    link_github: "https://github.com/KINGSLEYEHAPA/Kingsley-Ehapa-Portfolio",
    link_deployment: "https://sharp-fermat-7b6e4e.netlify.app/",
    projectType: "My Porfolio V1",
  },
];
